import { makeStyles } from "@material-ui/core"
import { McKSansMedium } from "../../styles/fonts"
import { useTranslation } from "react-i18next";
import {HiredateValidationForm, HiredateLabelHint } from "..";


const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        alignContent: 'center',
    },
    heading: {
        fontFamily: McKSansMedium,
        fontSize: '40px',
        textAlign: 'center',
        [theme.breakpoints.down('xs')]: {
            fontSize: '36px',
        }
    }
}))

const HiredateValidation = () => {
    const classes = useStyles()
    const {t} = useTranslation('common');
    return (
        <div className={classes.root}>
            <h3 className={classes.heading}>{t('get_hire_date.title')}</h3>
           <HiredateLabelHint />
           
            <HiredateValidationForm />
        </div>
    )
}

export default HiredateValidation